import * as rt from 'runtypes';
import { WordFinal } from '../data/WordBase';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

export function merge(s: WordFinal, sep: string = "; "): string {
  if (!s) return "";
  return (rt.Array(rt.String).guard(s)) ? s.join(sep) : s;
}